<template>
    <BaseWidget v-bind="$attrs" :widget="meta" :loading="loading">
        <div class="dw-sms-credit-body">
            <span class="dw-sms-provider-badge">{{ providerName() }}</span>
            <div class="dw-sms-credit-hero">
                <span class="dw-sms-credit-hero-num">{{ smsCreditFormatted }}</span>
                <span class="dw-sms-credit-hero-unit">SMS Kredi</span>
            </div>
            <div class="dw-metrics dw-metrics--bottom">
                <div class="dw-metric">
                    <i class="bi bi-wallet2" style="color: var(--bs-success)"></i>
                    <div class="dw-metric-text">
                        <span class="dw-metric-val">{{ balanceFormatted }} ₺</span>
                        <span class="dw-metric-lbl">Bakiye</span>
                    </div>
                </div>
                <div class="dw-metric-sep"></div>
                <div class="dw-metric">
                    <i class="bi bi-send" style="color: var(--bs-info)"></i>
                    <div class="dw-metric-text">
                        <span class="dw-metric-val">{{ smsCreditFormatted }}</span>
                        <span class="dw-metric-lbl">Kalan SMS</span>
                    </div>
                </div>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '../BaseWidget.vue';
import widgetMixin from '../widgetMixin';

export const meta = {
    id: 'sms_credit',
    titleKey: 'common.dashboard.widgetTitles.sms_credit',
    icon: 'bi-chat-dots',
    accent: 'var(--bs-success)',
    accentBg: 'rgba(var(--bs-success-rgb, 80, 205, 137), 0.12)',
    glassRgb: '80, 205, 137',
    defaultCol: 1,
    defaultRow: 1,
    multiInstance: true,
    source: { type: 'module', moduleCode: 'NETGSM', code: 'BALANCE' },
    defaultConfig: { provider: 'NETGSM' },
    configFields: [
        { key: 'provider', label: 'common.dashboard.widgetFields.provider', type: 'sms_provider_select' },
    ],
};

export default {
    name: 'SmsCreditWidget',
    components: { BaseWidget },
    mixins: [widgetMixin],
    data() {
        return { meta };
    },
    computed: {
        items() {
            return this.apiData?.items || [];
        },
        smsCreditFormatted() {
            const c = this.items.find(i => i.type === 'SMS_CREDIT');
            const n = parseInt(String(c?.amount ?? '0').replace(/[^\d]/g, ''), 10) || 0;
            return n.toLocaleString('tr-TR');
        },
        balanceFormatted() {
            const b = this.items.find(i => i.type === 'BALANCE');
            const raw = String(b?.amount ?? '0').replace(',', '.');
            const n = parseFloat(raw) || 0;
            return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
    },
};
</script>

<style>
.dw-sms-credit-hero {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
}
.dw-sms-credit-hero-num {
    font-size: 42px;
    font-weight: 800;
    color: var(--bs-body-color);
    letter-spacing: -1px;
    line-height: 1;
    background: linear-gradient(135deg, #10B981, #34D399);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}
.dw-sms-credit-hero-unit {
    font-size: 11px;
    font-weight: 500;
    color: var(--bs-gray-500);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}
</style>
